export function uncurry<A, B, R>(fn: (a: A) => (b: B) => R): (a: A, b: B) => R {
  // eslint-disable-next-line func-names
  return function (a: A, b: B): R {
    return fn(a)(b)
  }
}
